import { motion } from "framer-motion";
import { Star, Quote, ExternalLink } from "lucide-react";
import { TESTIMONIALS, TREATWELL_URL } from "@/data/salon";

export const Testimonials = () => {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 sm:py-32 bg-burgundy text-cream">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-16">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-pink">Client Voices</span>
          <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">Words from the mirror</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.blockquote
              key={t.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="relative rounded-3xl border border-pinklight/20 bg-cream/5 p-8 backdrop-blur-sm"
            >
              <Quote className="h-8 w-8 text-pink/60 mb-4" />
              <p className="font-serif text-xl sm:text-2xl leading-relaxed text-cream/90 italic">"{t.quote}"</p>
              <div className="mt-6 flex items-center justify-between">
                <div>
                  <p className="font-medium tracking-wide">{t.name}</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-pinklight/70">{t.service} · Verified</p>
                </div>
                <div className="flex gap-0.5">{[...Array(t.rating)].map((_, j) => <Star key={j} className="h-4 w-4 fill-pink text-pink" />)}</div>
              </div>
            </motion.blockquote>
          ))}
        </div>

        {/* Reviews CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          data-testid="reviews-cta"
          className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-6 rounded-3xl border border-goldlight/20 bg-cream/5 p-8 text-center sm:text-left"
        >
          <div className="flex items-center gap-4">
            <div>
              <p className="font-serif text-5xl text-pink leading-none">4.3</p>
              <div className="mt-1 flex gap-0.5">{[...Array(5)].map((_, i) => <Star key={i} className={`h-3.5 w-3.5 ${i < 4 ? "fill-pink text-pink" : "text-goldlight/40"}`} />)}</div>
            </div>
            <p className="max-w-xs text-sm text-cream/70">Rated by real clients across our studios. Read our reviews or leave your own.</p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <a
              href={TREATWELL_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="reviews-treatwell-link"
              className="flex items-center gap-2 rounded-full bg-pink px-6 py-3 text-xs uppercase tracking-[0.15em] text-cream hover:bg-cream hover:text-ink transition-colors"
            >
              Reviews on Treatwell <ExternalLink className="h-3.5 w-3.5" />
            </a>
            <a
              href="https://www.google.com/search?q=Fabrowz+beauty+salon+reviews"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="reviews-google-link"
              className="flex items-center gap-2 rounded-full border border-goldlight/30 px-6 py-3 text-xs uppercase tracking-[0.15em] text-cream hover:border-pink transition-colors"
            >
              Review us on Google <ExternalLink className="h-3.5 w-3.5" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
